import { arrayMap } from '@/app/utils/nativeArray';
import { app } from '@/store';

/**
 * renderFontList
 */
export async function renderFontList(needLoadData: boolean, data: any) {
  const { settings } = data;
  const $element = data.$element;
  const elementValue = $element.attr('value');
  let fontValues = typeof elementValue !== 'undefined' ? elementValue : '';
  fontValues = arrayMap(fontValues.split(','), (item: any) => item.trim()); // check if value is applied more than 1 (mostly is only 1)
  let $gfFontSelect;
  if (needLoadData) {
    $gfFontSelect = $(`<div class="gfFontSelect newFontManager">
          <div class="gfSGSubTitle">${settings.title}</div>
          <div class="gfSGclear"></div>
          <div class="gfFSRight"></div>
        </div>`);
    $element.after($gfFontSelect);
  } else {
    $gfFontSelect = $element.next('.gfFontSelect');
  }

  if ($gfFontSelect.width() == 0) {
    // html element inside this $ is removed
    $gfFontSelect = $element.next('.gfFontSelect');
  }

  let selectedValue = fontValues[0];
  const $gfFSRight = $gfFontSelect.find('.gfFSRight');

  const fontFamilys = await (app as any).$store.getters['font/pageFonts'];

  const fontFamilysOptions = arrayMap(
    fontFamilys,
    (fontFamily: any) => `
        <option value="${fontFamily.styleName}">
          ${fontFamily.googleName}
        </option>
      `,
  );

  /**
   * Apply deactivate font
   */
  if (!selectedValue) {
    selectedValue = 'inherit';
  } else {
    const appliedFont = fontFamilys.find((font: any) => font.styleName == selectedValue);
    if (!appliedFont) {
      fontFamilysOptions.push(`
         <option value="${encodeURI(
           selectedValue,
         )}" warning="This font has been deactivated, you can activate in Font Manager or select another font.">
             ${selectedValue}
          </option>
      `);
    }
  }
  const nameElement = $element.attr("name");
  const template = `
    <select name="${nameElement}" data-font-picker="true" value="${selectedValue}">
      ${fontFamilysOptions.join('')}
    </select>
 `;

  $gfFSRight.html(template);

  $gfFontSelect.find('select').gfDropDown({
    /**
     * onSelected
     */
    onSelected: function (value: any) {
      if (value == '') {
        value = 'inherit';
      }
      $element.attr('value', value).val(value).trigger('input-change').trigger('font-change').trigger('history-change');
    },
    newOptionStyle: true,
    moreActions: {
      html: `
            <div class="openFontManager">
              <p>Open Font Manager</p>
            </div>
          `,
      /**
       * applyEvents
       */
      applyEvents($item: any, closeDropdown: any) {
        $item.on('click', async function () {
          await (app as any).$store.dispatch('font/openFontManager', true);
          closeDropdown();
        });
      },
    },
  });

  const elementId = $element.attr('id');
  await (app as any).$store.commit('font/APPLY_SETUP_FONT_SELETOR', {
    id: elementId,
    data: {
      settings,
      id: elementId,
    },
  });
}
